import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(
  _theme => ({
    addButtonContainer: {
      alignItems: "center",
      backgroundColor: "#ffffff",
      border: "1px solid #0030FF",
      borderRadius: 50,
      color: "#0030FF",
      cursor: "pointer",
      display: "flex",
      fontWeight: "bold",
      gap: "5px",
      height: "24px",
      justifyContent: "space-between",
      width: "fit-content",
      zIndex: 1
    },
    addSignContainer: {
      backgroundColor: "#0030FF",
      borderRadius: 100,
      color: "#ffffff",
      fontWeight: "bold",
      padding: "0 4px"
    },
    container: {
      alignItems: "center",
      display: "flex",
      height: "fit-content",
      justifyContent: "center",
      margin: "24px 0 4px",
      position: "relative",
      width: "100%"
    },
    dashedLine: {
      background:
        "repeating-linear-gradient(90deg,lightgrey 0 5px ,#0000 0 7px) center",
      height: 1,
      position: "absolute",
      width: "100%"
    }
  }),
  { name: "AddCardComponent" }
);

export default useStyles;
